import API from 'utils/API'

export const fetchSlideshow = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/slideshow${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createSlideshow = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/slideshow', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchSlideshowDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/slideshow/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateSlideshow = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/slideshow/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteSlideshow = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/slideshow/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchWebSlideshow = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/web/slideshow${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
